<template>
  <div class="root">
    <div class="title-bar" v-if="$isEE">
      <div class="left">
        <img
          src="@assets/imgs/logoWhite.png"
          class="logo"
          alt=""
          style="height: 45px"
        />
        <i class="headLeftTitle">KVIS-CLOUD</i>
      </div>
      <div class="controls">
        <a-icon type="minus" @click="minimizeWindow" />
        <a-icon type="border" @click="maximizeOrRestoreWindow" />
        <a-icon type="close" @click="closeWindow" />
      </div>
    </div>
    <div class="bigbox">
      <div class="swiper">
        <a-carousel autoplay style="height: 100%" dotsClass="dots">
          <div>
            <h3 class="swiper">
              <img src="@assets/imgs/login4.png" alt="" class="Img" />
            </h3>
          </div>
        </a-carousel>
      </div>
      <div class="login">
        <h1 class="loginTitle">
          <img src="@assets/imgs/logo.svg" alt="" style="height: 80px" />
          <br />
          <span style="fontsize: 16px"> 人工智能 AI训练平台 </span><br />
        </h1>
        <div style="marginbottom: 20px">
          <span style="fontsize: 12px">
            专为企业提供专属的高性能GPU的AI训练平台
          </span>
        </div>
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
              v-decorator="[
                'account',
                {
                  rules: [{ required: true, message: '请输入您的用户名' }],
                },
              ]"
              placeholder="用户名"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入您的密码' }],
                },
              ]"
              type="password"
              placeholder="密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-checkbox
              v-decorator="[
                'remember',
                {
                  valuePropName: 'checked',
                  initialValue: true,
                },
              ]"
            >
              记住我
            </a-checkbox>
            <a class="login-form-forgot" target="_blank" href="https://cloud.keyetech.com/train-service"> 返回新版 </a>
            <a-button
              type="primary"
              html-type="submit"
              class="login-form-button"
            >
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="footer">
      <div class="copyright">Copyright &copy; 2022 科亿科技</div>
    </div>
  </div>
</template>

<script>
import { login } from "@api";
import ipcApiRoute from "@/utils/bridge";
export default {
  name: "Login",
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    minimizeWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerMinimize);
    },
    maximizeOrRestoreWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerMaximize);
    },
    closeWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerClose);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        // if (!err) {
        //   console.log("Received values of form: ", values);
        // } else {
        console.log(values);

        if (this.$isEE) {
          this.handlerSaveUser(
            values.remember
              ? values
              : {
                  account: "",
                  password: "",
                }
          );
        }
        login(values).then((res) => {
          console.log(res);
          if (res.code > 0) {
            this.$message.success("登录成功", 1, () => {
              localStorage.setItem("user_name", values["account"]);
              localStorage.setItem("user_id", res.data.userId);
              localStorage.setItem("ownUpdateJsonConfig",res.data.ownUpdateJsonConfig);
              localStorage.setItem("ownDownloadNonEncryptedModel",res.data.ownDownloadNonEncryptedModel);
              // this.$store.commit('initusername',values.account)
              this.$router.replace({
                path: "/",
                query: `${values.account}`,
              });
            });
          } else {
            this.$message.error("用户名或密码错误", 1);
          }
        });
      });
    },
    handlerGetUser() {
      this.$ipc.invoke(ipcApiRoute.handlerGetUser).then((res) => {
        if (res != undefined) {
          this.form.setFieldsValue({
            account: res.account,
            password: res.password,
          });
        }
      });
    },
    handlerSaveUser({ account, password }) {
      this.$ipc.invoke(ipcApiRoute.handlerSaveUser, { account, password });
    },
  },
  mounted() {
    if (this.$isEE) {
      this.handlerGetUser();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
.title-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #001529;
  -webkit-app-region: drag;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
  }
  .logo {
    margin-left: 20px;
    margin-right: 40px;
  }
  .headLeftTitle {
    font-size: 30px;
    margin: 10px;
    font-weight: 700;
    font-family: Arial;
    color: #fff;
  }
  .controls {
    -webkit-app-region: no-drag;
    z-index: 9999;

    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 20px;
    > * {
      color: red;
      font-size: 20px;
      margin-left: 30px;
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
